<div class="chips-container">
    <app-colored-chip *ngFor="let chip of chips" [backgroundColor]="chip.backgroundColor" [borderColor]="chip.borderColor" [color]="chip.color" [text]="chip.text" [opacity]="chip.opacity || 1"></app-colored-chip>
</div>
